import { SingleLineAddressOnListing } from '@/components/Address'
import { capitalize } from '@/utils/strings'

const BienItemLocataire = ({ bien }) => {
  const handleRowClick = (bienId) => {
    window.location.href = `/extranet/locataire/biens/${bienId}` // Rediriger vers la page de détails du bien cliqué
  }

  const formatPrice = (price) => {
    return price ? `${price.toLocaleString('fr-FR')} €` : '-'
  }

  return (
    <tr className="cursor-pointer hover:bg-primary-200 transition-all duration-500"
        onClick={() => handleRowClick(bien.id)}
    >
      <td>{capitalize(bien.type_bien)}</td>
      <td>{formatPrice(bien.location?.prix_loyer)}</td>
      <td>{formatPrice(bien.location?.montant_charges_total)}</td>
      <td>
        <SingleLineAddressOnListing data={bien} withCodePostal={true} />
      </td>
      <td>{bien.surface_carrez ? `${bien.surface_carrez} m²` : '-'}</td>
    </tr>
  )
}

export default BienItemLocataire